export const defaultToastData = {
    showToast: false,
    heading: "Fetching order details",
    message: "We are fetching your order details and generating cart. This may take a few seconds."
}